import { withStyles } from '@material-ui/core/styles';
import InputBase from '@material-ui/core/InputBase';

const SelectInput = withStyles((theme) => ({
  root: {
    'label + &': {
      marginTop: theme.spacing(2),
    },
  },
  input: {
    borderRadius: 25,
    position: 'relative',
    backgroundColor: "white",
    border: '1px solid #ced4da',
    fontSize: 16,
    padding: '15px 26px 15px 12px',
    marginBottom: "30px",
    width: "100%",
    transition: theme.transitions.create(['border-color', 'box-shadow']),
    // Use the system font instead of the default Roboto font.
    fontFamily: [
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(','),
    '&:focus': {
      borderRadius: 25,
      backgroundColor: "white",
    },
  },
}))(InputBase);

const TransparentInput = withStyles((theme) => ({
  root: {
    'label + &': {
      marginTop: theme.spacing(2),
    },
  },
  input: {
    borderRadius: 25,
    position: 'relative',
    backgroundColor: "rgba(255,255,255,0)",
    border: 'none',
    fontSize: "16px",
    fontWeight: 'bold',
    color:  'white',
    padding: '0px',
    marginBottom: "0px",
    width: "100%",
    [theme.breakpoints.down(400)]: {
      fontSize: "12px"
    },
    // Use the system font instead of the default Roboto font.
    fontFamily: [
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ]
  },
}))(InputBase);

export {SelectInput, TransparentInput}